<!--
 * @Author: Asadhcj asadhcj@163.com
 * @Date: 2025-09-05 10:01:59
 * @LastEditors: Asadhcj asadhcj@163.com
 * @LastEditTime: 2026-03-03 14:00:00
 * @FilePath: \betdoce-admind:\new_project\betdoce-web\src\components\LoginDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <v-dialog
    v-if="!isMobile"
    transition="dialog-bottom-transition"
    v-model="show"
    :max-width="isMobile ? '100%' : '850'"
    class="login-dialog"
    :class="{ 'login-dialog-bottom': isMobile }"
    :fullscreen="false"
    :persistent="false"
    :scrim="true"
    @click:outside="handleClose"
  >
    <div class="login-card" :class="{ mobile: isMobile }">
      <!-- Mobile Header -->
      <div class="mobile-header" v-if="isMobile">
         <div style="background: rgba(255,255,255,0.1); border-radius: 50%; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;" @click="handleClose">
            <v-icon icon="mdi-close" color="#fff" size="18"></v-icon>
         </div>
      </div>
      
      <!-- Mobile Title Section -->
      <div class="px-4" v-if="isMobile">
        <h2 class="text-h5 font-weight-black text-white mb-1 mt-4">
          {{ isSignUpMode ? 'Crie sua conta' : 'Faça login na sua conta' }}
        </h2>
        <div class="text-grey-lighten-1 mb-1 text-body-2">
          {{ isSignUpMode ? 'Já tem uma conta?' : 'Não tem uma conta?' }}
          <span style="color: #FFD700; font-weight: bold; cursor: pointer;" @click="toggleMode">
            {{ isSignUpMode ? 'Entrar' : 'Registro' }}
          </span>
        </div>
        <div v-if="props.expired" class="mb-4">
          <span style="color: #ff4d4f; font-size: 14px;">O login expirou. Por favor, faça o login novamente</span>
        </div>
      </div>

      <!-- 标题 -->
      <!-- <div style="text-align: right">
        <v-btn
          class="close-btn"
          icon="mdi-close"
          variant="text"
          @click="show = false"
        ></v-btn>
      </div> -->
      <!-- 登录方式切换 -->
      <div v-if="!isMobile && props.expired" class="mb-4 pa-3 text-center rounded mx-8 mt-4" style="background-color: rgba(255, 0, 0, 0.1); border: 1px solid rgba(255, 0, 0, 0.3);">
        <span style="color: #ff4d4f; font-size: 14px;">O login expirou. Por favor, faça o login novamente</span>
      </div>
      <div
        class="login-tabs d-flex flex-center"
        :style="!isPasswordLogin ? 'display: flex;' : ''"
        v-if="!isMobile"
      >
        <div
          class="d-flex mb-10"
          style="border-radius: 32px; background-color: rgb(33, 33, 33)"
        >
          <v-btn
            class="login-title-sign"
            value="sign"
            :class="{ activeTabBg: toggleModeBtn === 'sign' }"
          >
            <div
              class="login-title"
              style="flex: 1"
              v-if="isPasswordLogin"
              @click="toggleMode"
            >
              {{ "Registro" }}
            </div>
          </v-btn>
          <v-btn
            class="login-title-login"
            value="login"
            :class="{ activeTabBg: toggleModeBtn === 'login' }"
          >
            <div
              class="login-title"
              style="flex: 1"
              v-if="isPasswordLogin"
              @click="toggleMode"
            >
              {{ "Entrar" }}
            </div>
          </v-btn>
        </div>
        <v-btn
          v-if="!isPasswordLogin"
          :class="['tab-btn', { active: activeTab === 'phone' }]"
          variant="text"
          :ripple="false"
          @click="activeTab = 'phone'"
        >
          Telefone
        </v-btn>
      </div>
      <template v-if="isPasswordLogin">
        <v-text-field
          v-model="phone"
          variant="outlined"
          density="comfortable"
          :error-messages="phoneError"
          @input="phoneError = ''"
          label="Número de telefone celular"
          class="phone-input"
          placeholder="Digite seu número de celular"
          bg-color="#1F2937"
          ref="textField"
          @click:control="handleInputClick"
        >
          <template #prepend-inner>
            <div class="d-flex align-center mr-2" style="height: 100%">
              <span class="mr-2" style="font-size: 20px;">🇧🇷</span>
              <span class="text-white font-weight-bold mr-2">+55</span>
              <div style="width: 1px; height: 16px; background: rgba(255,255,255,0.2);"></div>
            </div>
          </template>
          <template #append-inner>
            <v-btn
              v-if="phone"
              variant="text"
              icon
              size="small"
              class="clear-btn"
              @click="clearPhone"
            >
              <v-icon color="rgba(255,255,255,0.5)" size="small"
                >mdi-close-circle</v-icon
              >
            </v-btn>
          </template>
        </v-text-field>

        <div class="code-input-wrapper">
          <v-text-field
            v-model="password"
            variant="outlined"
            density="comfortable"
            label="Senha"
            :error-messages="passwordError"
            @input="passwordError = ''"
            :type="showPasswordFlag ? 'text' : 'password'"
            class="code-input"
            placeholder="Digite sua senha"
            bg-color="#1F2937"
          >
            <template #prepend-inner>
              <v-icon
                color="rgba(255,255,255,0.7)"
                size="small"
                class="lock-icon"
                >mdi-key-variant</v-icon
              >
            </template>
            <template #append-inner>
              <v-btn
                v-if="password"
                variant="text"
                icon
                size="small"
                class="clear-btn"
                @click="clearPassword"
              >
                <v-icon color="rgba(255,255,255,0.5)" size="small"
                  >mdi-close-circle</v-icon
                >
              </v-btn>
              <v-btn
                variant="text"
                class="show-pass-btn"
                @click="showPassword"
              >
                <v-icon
                  color="rgba(255,255,255,0.7)"
                  size="small"
                  class="lock-icon"
                  >{{
                    showPasswordFlag ? "mdi-eye-outline" : "mdi-eye-off-outline"
                  }}</v-icon
                >
              </v-btn>
            </template>
          </v-text-field>

          <!-- 确认密码输入 (仅注册模式显示) -->
          <v-text-field
            v-if="isSignUpMode"
            v-model="confirmPassword"
            variant="outlined"
            density="comfortable"
            :error-messages="confirmPasswordError"
            @input="confirmPasswordError = ''"
            :type="showConfirmPasswordFlag ? 'text' : 'password'"
            class="code-input"
            placeholder="Digite a senha de confirmação"
            bg-color="#1F2937"
          >
            <template #prepend-inner>
              <v-icon
                color="rgba(255,255,255,0.7)"
                size="small"
                class="lock-icon"
                >mdi-key-variant</v-icon
              >
            </template>
            <template #append-inner>
              <v-btn
                v-if="confirmPassword"
                variant="text"
                icon
                size="small"
                class="clear-btn"
                @click="clearConfirmPassword"
              >
                <v-icon color="rgba(255,255,255,0.5)" size="small"
                  >mdi-close-circle</v-icon
                >
              </v-btn>
              <v-btn
                variant="text"
                class="show-pass-btn"
                @click="showConfirmPassword"
              >
                <v-icon
                  color="rgba(255,255,255,0.7)"
                  size="small"
                  class="lock-icon"
                  >{{
                    showConfirmPasswordFlag
                      ? "mdi-eye-outline"
                      : "mdi-eye-off-outline"
                  }}</v-icon
                >
              </v-btn>
            </template>
          </v-text-field>
          
          <div class="remember-forgot" v-if="!isSignUpMode">
            <v-checkbox
              v-model="rememberChecked"
              label="Lembrar"
              color="#32FFD6"
              class="remember-checkbox"
            />
            <span class="forgot-password" @click="openForgotDialog"
              >Esqueceu a senha?</span
            >
          </div>
        </div>
        <!-- 登录/注册/重置密码按钮 -->
        <v-btn
          block
          size="large"
          class="login-btn"
          :class="{ 'active-login-btn': activityBtn() }"
          :loading="loading"
          :disabled="loading || fingerprintLoading"
          :ripple="false"
          @click.stop="isSignUpMode ? handleSignUp() : handleLogin()"
        >
          {{ isSignUpMode ? "Registro" : "Entrar" }}
        </v-btn>
        <div class="sing-up-bottom">
          <v-checkbox
            v-if="isSignUpMode"
            v-model="tipsChecked"
            label="Declaro que tenho mais de 18 anos e aceito a Política de Privacidade e os Termos e Condições."
            color="#32FFD6"
            readonly
            class="tips-checkbox"
          />

          <!-- <span class="sign-up-btn" @click="toggleMode">{{
            isSignUpMode ? "Entrar" : "Registro"
          }}</span> -->
        </div>
      </template>
      <template v-if="!isPasswordLogin">
        <!-- 手机号输入 -->
        <v-text-field
          v-model="phone"
          variant="outlined"
          density="comfortable"
          :error-messages="phoneError"
          @input="phoneError = ''"
          label="Número de telefone celular"
          class="phone-input"
          placeholder="Digite seu número de celular"
          bg-color="#1F2937"
          ref="textField"
          @click:control="handleInputClick"
        >
          <template #prepend-inner>
            <div class="d-flex align-center mr-2" style="height: 100%">
              <span class="mr-2" style="font-size: 20px;">🇧🇷</span>
              <span class="text-white font-weight-bold mr-2">+55</span>
              <div style="width: 1px; height: 16px; background: rgba(255,255,255,0.2);"></div>
            </div>
          </template>
          <template #append-inner>
            <v-btn
              v-if="phone"
              variant="text"
              icon
              size="small"
              class="clear-btn"
              @click="clearPhone"
            >
              <v-icon color="rgba(255,255,255,0.5)" size="small"
                >mdi-close-circle</v-icon
              >
            </v-btn>
          </template>
        </v-text-field>

        <!-- 验证码输入 -->
        <div class="code-input-wrapper">
          <v-text-field
            v-model="verificationCode"
            variant="outlined"
            density="comfortable"
            :error-messages="verificationCodeError"
            @input="verificationCodeError = ''"
            class="code-input"
            placeholder="Código de verificação"
            bg-color="#1F2937"
          >
            <template #append-inner>
              <v-btn
                variant="text"
                class="send-code-btn"
                :disabled="countdown > 0"
                @click="sendCode"
              >
                <span>{{ countdown > 0 ? `${countdown}s` : "Enviar" }}</span>
              </v-btn>
            </template>
          </v-text-field>
        </div>
        <!-- <v-text-field v-model="password" variant="outlined" density="comfortable" label="Password" hide-details
            :type="showPasswordFlag ? 'text' : 'password'" class="code-input" placeholder="Enter your password"
            bg-color="#1F2937">
            <template #prepend-inner>
              <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">mdi-shield-lock-outline</v-icon>
            </template>
            <template #append-inner>
              <v-btn variant="text" class="show-pass-btn" :disabled="countdown > 0" @click="showPassword">
                <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">{{ showPasswordFlag ?
                  'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
              </v-btn>
            </template>
          </v-text-field> -->

        <!-- 确认密码输入 (仅注册模式显示) -->
        <!-- <v-text-field v-if="isSignUpMode" v-model="confirmPassword" variant="outlined" density="comfortable"
            label="Confirm Password" hide-details type="password" class="code-input" placeholder="Confirm your password"
            bg-color="#1F2937">
            <template #prepend-inner>
              <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">mdi-shield-lock-outline</v-icon>
            </template>
          </v-text-field>

          <div class="remember-forgot" v-if="!isSignUpMode">
            <v-checkbox v-model="showPasswordFlag" label="lembrar" color="#49C973" class="remember-checkbox" />
            <span class="forgot-password">esqueça a senha?</span>
          </div>
        </div> -->
        <!-- 登录/注册按钮 -->
        <v-btn
          block
          size="large"
          class="login-btn"
          :loading="loading"
          :ripple="false"
          @click.stop="isSignUpMode ? handleSignUp() : handleLogin()"
        >
          {{ isSignUpMode ? "Registro" : "Entrar" }}
        </v-btn>
        <!-- <div class="sing-up-bottom">
          {{ isSignUpMode ? 'Já tem uma conta？' : "Nenhuma conta ainda?" }}
          <span class="sign-up-btn" @click="toggleMode">{{ isSignUpMode ? 'Entrar' : 'Registro' }}</span>
        </div> -->
      </template>
    </div>
  </v-dialog>

  <v-dialog
    v-model="showForgotDialog"
    max-width="360"
    :fullscreen="false"
    class="forgot-dialog"
    :scrim="true"
    @click:outside="closeForgotDialog"
  >
    <div class="forgot-card">
      <div class="forgot-card-header">
        <div class="forgot-card-title">Esqueceu a senha</div>
        <v-btn icon variant="text" class="forgot-close-btn" @click="closeForgotDialog">
          <v-icon icon="mdi-close" color="#fff" size="18"></v-icon>
        </v-btn>
      </div>
      <div class="forgot-subtitle">Recupere a senha conforme as instruções</div>
      <div class="forgot-steps">
        <div :class="['forgot-step', { active: forgotStep >= 1 }]">1</div>
        <div class="forgot-step-line" :class="{ active: forgotStep >= 2 }"></div>
        <div :class="['forgot-step', { active: forgotStep >= 2 }]">2</div>
        <div class="forgot-step-line" :class="{ active: forgotStep >= 3 }"></div>
        <div :class="['forgot-step', { active: forgotStep >= 3 }]">3</div>
      </div>

      <template v-if="forgotStep === 1">
        <div class="form-title">Verificar identidade</div>
        <v-text-field
          v-model="phone"
          variant="outlined"
          density="comfortable"
          :error-messages="phoneError"
          @input="phoneError = ''"
          class="phone-input"
          placeholder="Número de telefone celular"
          bg-color="#1F2937"
        >
          <template #prepend-inner>
            <div class="d-flex align-center mr-2" style="height: 100%">
               <img src="@/assets/images/78tt/br-Yf30zEjB.svg" style="width: 20px; height: 20px; margin-right: 8px; border-radius: 50%; object-fit: cover;" alt="BR" />
              <span class="text-white font-weight-bold mr-2">+55</span>
              <div style="width: 1px; height: 16px; background: rgba(255,255,255,0.2);"></div>
            </div>
          </template>
        </v-text-field>
      </template>

      <template v-if="forgotStep === 2">
        <div class="form-title">Obter código de verificação</div>
        <div class="text-grey-lighten-1 text-body-2 mb-2">
          O código de verificação será enviado para o seu celular
        </div>
        <div class="code-input-wrapper">
          <v-text-field
            v-model="verificationCode"
            variant="outlined"
            density="comfortable"
            :error-messages="verificationCodeError"
            @input="verificationCodeError = ''"
            class="code-input"
            placeholder="Código de verificação"
            bg-color="#1F2937"
          >
            <template #append-inner>
              <v-btn
                variant="text"
                class="send-code-btn"
                :disabled="countdown > 0"
                @click="sendCode"
              >
                <span>{{ countdown > 0 ? `${countdown}s` : "Enviar" }}</span>
              </v-btn>
            </template>
          </v-text-field>
        </div>
      </template>

      <template v-if="forgotStep === 3">
        <div class="form-title">Redefinir senha</div>
        <v-text-field
          v-model="newPassword"
          variant="outlined"
          density="comfortable"
          label=""
          :error-messages="newPasswordError"
          @input="newPasswordError = ''"
          :type="showPasswordFlag ? 'text' : 'password'"
          class="code-input"
          placeholder="Digite sua nova senha"
          bg-color="#1F2937"
        >
          <template #prepend-inner>
            <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">mdi-key-variant</v-icon>
          </template>
          <template #append-inner>
            <v-btn variant="text" class="show-pass-btn" @click="showPassword">
              <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">{{
                showPasswordFlag ? "mdi-eye-outline" : "mdi-eye-off-outline"
              }}</v-icon>
            </v-btn>
          </template>
        </v-text-field>

        <v-text-field
          v-model="confirmNewPassword"
          variant="outlined"
          density="comfortable"
          label=""
          :error-messages="confirmNewPasswordError"
          @input="confirmNewPasswordError = ''"
          :type="showConfirmPasswordFlag ? 'text' : 'password'"
          class="code-input"
          placeholder="Digite a senha de confirmação"
          bg-color="#1F2937"
        >
          <template #prepend-inner>
            <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">mdi-key-variant</v-icon>
          </template>
          <template #append-inner>
            <v-btn variant="text" class="show-pass-btn" @click="showConfirmPassword">
              <v-icon color="rgba(255,255,255,0.7)" size="small" class="lock-icon">{{
                showConfirmPasswordFlag ? "mdi-eye-outline" : "mdi-eye-off-outline"
              }}</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </template>

      <v-btn
        block
        size="large"
        class="login-btn"
        :class="{ 'active-login-btn': forgotStep === 1 ? !!phone : forgotStep === 2 ? !!verificationCode : !!newPassword && !!confirmNewPassword }"
        :loading="loading"
        @click="handleForgotAction"
      >
        Confirmar
      </v-btn>
    </div>
  </v-dialog>

  <teleport to="body">
    <div v-if="isMobile && show" class="mobile-login-overlay" @click="handleClose">
       <div class="mobile-drawer-header">
           <img src="@\assets\images\78tt\header-logo.png" class="drawer-logo" alt="Logo" />
           <div class="close-btn" @click="handleClose">
             <v-icon icon="mdi-close" color="#fff" size="18"></v-icon>
           </div>
        </div>
      <div class="mobile-login-drawer" @click.stop>
        
        <div class="drawer-content">
          <!-- Title -->
          <h2 class="text-h5 font-weight-black text-white mb-1 mt-4 text-left">
            {{ isSignUpMode ? 'Crie sua conta' : 'Faça login na sua conta' }}
          </h2>
          <div class="text-grey-lighten-1 mb-1 text-body-2 text-left">
            {{ isSignUpMode ? 'Já tem uma conta?' : 'Não tem uma conta?' }}
            <span style="color: #FFD700; font-weight: bold; cursor: pointer;" @click="toggleMode">
              {{ isSignUpMode ? 'Entrar' : 'Registro' }}
            </span>
          </div>
          <div v-if="props.expired" class="mb-4 text-left">
            <span style="color: #ff4d4f; font-size: 14px;">O login expirou. Por favor, faça o login novamente</span>
          </div>
          
          <!-- Form Fields (Duplicated from Dialog) -->
          <template v-if="isPasswordLogin">
            <v-text-field
              v-model="phone"
              variant="outlined"
              density="comfortable"
              :error-messages="phoneError"
              @input="phoneError = ''"
              class="mobile-input"
              placeholder="Número de telefone celular"
              bg-color="#0d131f"
              ref="textField"
              @click:control="handleInputClick"
            >
              <template #prepend-inner>
                <div class="d-flex align-center mr-2" style="height: 100%">
                  <img src="@/assets/images/78tt/br-Yf30zEjB.svg" style="width: 20px; height: 20px; margin-right: 8px; border-radius: 50%; object-fit: cover;" alt="BR" />
                  <span class="text-white font-weight-bold mr-2">+55</span>
                  <div style="width: 1px; height: 16px; background: rgba(255,255,255,0.2);"></div>
                </div>
              </template>
              <template #append-inner>
                <v-btn v-if="phone" variant="text" icon size="small" class="clear-btn" @click="clearPhone">
                  <v-icon color="rgba(255,255,255,0.5)" size="small">mdi-close-circle</v-icon>
                </v-btn>
              </template>
            </v-text-field>
            
            <div class="code-input-wrapper">
               <v-text-field
                  v-model="password"
                  variant="outlined"
                  density="comfortable"
                  label=""
                  :error-messages="passwordError"
                  @input="passwordError = ''"
                  :type="showPasswordFlag ? 'text' : 'password'"
                  class="mobile-input"
                  placeholder="Digite sua senha"
                  bg-color="#0d131f"
                >
                  <template #prepend-inner>
                    <v-icon color="rgba(255,255,255,0.7)" size="small">mdi-key-variant</v-icon>
                  </template>
                  <template #append-inner>
                    <v-btn v-if="password" variant="text" icon size="small" @click="clearPassword">
                       <v-icon color="rgba(255,255,255,0.5)" size="small">mdi-close-circle</v-icon>
                    </v-btn>
                    <v-btn variant="text" @click="showPassword">
                       <v-icon color="rgba(255,255,255,0.7)" size="small">{{ showPasswordFlag ? "mdi-eye-outline" : "mdi-eye-off-outline" }}</v-icon>
                    </v-btn>
                  </template>
               </v-text-field>
               
               <v-text-field
                  v-if="isSignUpMode"
                  v-model="confirmPassword"
                  variant="outlined"
                  density="comfortable"
                  :error-messages="confirmPasswordError"
                  @input="confirmPasswordError = ''"
                  :type="showConfirmPasswordFlag ? 'text' : 'password'"
                  class="mobile-input"
                  placeholder="Digite a senha de confirmação"
                  bg-color="#0d131f"
                >
                  <template #prepend-inner>
                    <v-icon color="rgba(255,255,255,0.7)" size="small">mdi-key-variant</v-icon>
                  </template>
                  <template #append-inner>
                    <v-btn v-if="confirmPassword" variant="text" icon size="small" @click="clearConfirmPassword">
                       <v-icon color="rgba(255,255,255,0.5)" size="small">mdi-close-circle</v-icon>
                    </v-btn>
                    <v-btn variant="text" @click="showConfirmPassword">
                       <v-icon color="rgba(255,255,255,0.7)" size="small">{{ showConfirmPasswordFlag ? "mdi-eye-outline" : "mdi-eye-off-outline" }}</v-icon>
                    </v-btn>
                  </template>
               </v-text-field>
               
               <div class="remember-forgot" v-if="!isSignUpMode">
                  <v-checkbox v-model="rememberChecked" label="Lembrar" color="#32FFD6" class="remember-checkbox" hide-details density="compact" />
                  <span class="forgot-password" @click="openForgotDialog">Esqueceu a senha?</span>
               </div>
            </div>

            <!-- Action Button -->
            <v-btn
              block
              size="large"
              class="mobile-login-btn"
              :loading="loading"
              :disabled="loading || fingerprintLoading"
              :ripple="false"
              @pointerdown.stop
              @click.stop="isSignUpMode ? handleSignUp() : handleLogin()"
            >
              {{ isSignUpMode ? "Registro" : "Entrar" }}
            </v-btn>

            <div class="sing-up-bottom">
              <v-checkbox
                v-if="isSignUpMode"
                v-model="tipsChecked"
                label="Declaro que tenho mais de 18 anos e aceito a Política de Privacidade e os Termos e Condições."
                color="#32FFD6"
                readonly
                class="tips-checkbox"
                hide-details
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { showError, showSuccess } from "@/utils/toast";
import { normalizeRequestParams, md5Encrypt } from "@/utils";
import { setToken } from "@/utils/auth";
import { getAndClearTargetRoute } from "@/utils/auth";
import websocketService from "@/utils/websocket";
import { parseUrlParams } from "@/utils/url";
import { getShortLinkDetail, loginDevice, resetPassword } from "@/api/auth";
import { eventBus, LOGIN_EVENTS } from "@/utils/eventBus";
import { generateDeviceFingerprint } from "@/utils/device";
import { GoogleTag } from "@/utils/auth";
import { getFingerprintPayload } from "@/utils/fingerprint";

const store = useStore();
const router = useRouter();
const textField = ref();
const windowWidth = ref(window.innerWidth);

const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});

// 使用自定义的设备检测逻辑
const isMobile = computed(() => {
  // return windowWidth.value <= 768;
  return true; // 强制使用移动端样式
});

const isPasswordLogin = computed(() => {
  return import.meta.env.VITE_IS_PASSWORD_LOGIN === "true" || isMobile.value;
});

function getDeviceCode() {
  const userAgent = navigator.userAgent;
  let deviceCode = 0; // Default to 0 if no match is found

  const devicePatterns = {
    "1": /Windows NT/i, // PC-Windows
    "2": /Macintosh/i, // PC-MacOS
    "3": /iPhone|iPad|iPod/i, // H5-iOS
    "4": /Android/i, // H5-Android
  };

  for (const [code, pattern] of Object.entries(devicePatterns)) {
    if (pattern.test(userAgent)) {
      deviceCode = parseInt(code);
      break;
    }
  }

  return deviceCode;
}

const props = defineProps<{
  modelValue: boolean;
  isLogin?: boolean;
  expired?: boolean;
}>();
const origin_link = ref("");
const activityObj = ref<{
  activity_id?: string | number;
  invite_code?: string;
  channel?: string;
  agent_invite_code?: string;
  pdd_invite_code?: string;
}>({});

// 定义ShortLinkResponse接口
interface ShortLinkResponse {
  origin_link?: string;
  [key: string]: any;
}
const RESERVED_INVITE_CODES = new Set(["register", "recharge"]);
const emit = defineEmits(["update:modelValue", "login"]);

const show = ref(props.modelValue);
const activeTab = ref("phone");
const phone = ref("");
const verificationCode = ref("");
const password = ref("");
const loading = ref(false);
const fingerprintLoading = ref(false);
const countdown = ref(0);
const showPasswordFlag = ref(false);
const showConfirmPasswordFlag = ref(false);

const rememberChecked = ref(false);
const tipsChecked = ref(true);

// 记住密码相关的常量
const REMEMBER_PASSWORD_KEY = "remembered_password";
const REMEMBER_PHONE_KEY = "remembered_phone";
const REMEMBER_CHECKED_KEY = "remember_checked";
const isSignUpMode = ref(true);
const toggleModeBtn = ref("sign");
const confirmPassword = ref("");
const cpf = ref("");
const showForgotDialog = ref(false);
const newPassword = ref("");
const confirmNewPassword = ref("");
const forgotStep = ref(1);

// Error Refs
const phoneError = ref("");
const passwordError = ref("");
const confirmPasswordError = ref("");
const cpfError = ref("");
const verificationCodeError = ref("");
const newPasswordError = ref("");
const confirmNewPasswordError = ref("");

// 组件挂载时恢复记住的密码
onMounted(() => {
  restoreRememberedPassword();
});

const getStoredInviteCode = () => {
  const inviteCode = sessionStorage.getItem("invite_code") || "";
  if (!inviteCode || RESERVED_INVITE_CODES.has(inviteCode)) {
    return "";
  }
  return inviteCode;
};

const getShortLinkCode = () => localStorage.getItem("inviteCode") || "";

const clearInviteTracking = () => {
  sessionStorage.removeItem("invite_code");
  sessionStorage.removeItem("agent_invite_code");
  localStorage.removeItem("inviteCode");
};

const syncInviteContext = async () => {
  origin_link.value = "";
  activityObj.value = {};

  const shortLinkCode = getShortLinkCode();
  if (!shortLinkCode) {
    return;
  }

  const res = await getShortLinkDetail(shortLinkCode);
  const shortLinkRes = res as ShortLinkResponse;
  origin_link.value = shortLinkRes?.origin_link || "";
  if (!origin_link.value) {
    return;
  }

  activityObj.value = parseUrlParams(origin_link.value);
  if (activityObj.value?.agent_invite_code) {
    sessionStorage.setItem(
      "agent_invite_code",
      activityObj.value?.agent_invite_code || ""
    );
  }
};

const applyDialogVisibility = (val: boolean) => {
  show.value = val;
  if (val && sessionStorage.getItem("openRegisterMode") === "true") {
    isSignUpMode.value = true;
    toggleModeBtn.value = "sign";
    sessionStorage.removeItem("openRegisterMode");
  }
};

// 恢复记住的密码
const restoreRememberedPassword = () => {
  const rememberedChecked = localStorage.getItem(REMEMBER_CHECKED_KEY);
  if (rememberedChecked === "true" && props.isLogin) {
    isSignUpMode.value = false;
    toggleModeBtn.value = "login";
    rememberChecked.value = true;
    const rememberedPhone = localStorage.getItem(REMEMBER_PHONE_KEY);
    const rememberedPassword = localStorage.getItem(REMEMBER_PASSWORD_KEY);

    if (rememberedPhone) {
      phone.value = rememberedPhone;
    }
    if (rememberedPassword) {
      password.value = rememberedPassword;
    }
  }
};

// 保存密码到本地存储
const savePasswordToStorage = () => {
  if (rememberChecked.value) {
    localStorage.setItem(REMEMBER_PHONE_KEY, phone.value);
    localStorage.setItem(REMEMBER_PASSWORD_KEY, password.value);
    localStorage.setItem(REMEMBER_CHECKED_KEY, "true");
  } else {
    // 如果未勾选记住密码，清除已保存的密码
    localStorage.removeItem(REMEMBER_PHONE_KEY);
    localStorage.removeItem(REMEMBER_PASSWORD_KEY);
    localStorage.removeItem(REMEMBER_CHECKED_KEY);
  }
};

// 重置弹窗状态到初始登录模式
const resetDialogToLoginMode = () => {
  // 重置所有模式状态
  isSignUpMode.value = props.isLogin ? false : true;
  toggleModeBtn.value = props.isLogin ? "login" : "sign";
  showForgotDialog.value = false;
  forgotStep.value = 1;
  activeTab.value = "phone";
  countdown.value = 0;

  // 清空表单数据
  phone.value = "";
  password.value = "";
  verificationCode.value = "";
  newPassword.value = "";
  confirmNewPassword.value = "";
  cpf.value = "";

  confirmPassword.value = "";
  // 重置密码显示状态
  showPasswordFlag.value = false;
  showConfirmPasswordFlag.value = false;
  
  // 清除错误信息
  phoneError.value = "";
  passwordError.value = "";
  confirmPasswordError.value = "";
  cpfError.value = "";
  verificationCodeError.value = "";
  newPasswordError.value = "";
  confirmNewPasswordError.value = "";

  // 检查并恢复记住的账号密码
  restoreRememberedPassword();
};

// 监听 modelValue 变化
watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      // 每次打开弹窗时重置到登录模式
      resetDialogToLoginMode();
    }

    if (getShortLinkCode()) {
      syncInviteContext()
        .catch((err) => {
          console.error("Failed to fetch short link details:", err);
        })
        .finally(() => {
          applyDialogVisibility(val);
        });
    } else {
      applyDialogVisibility(val);
    }
  }
);

// 监听 show 变化
watch(show, (val) => {
  emit("update:modelValue", val);
});

// 验证手机号
const validatePhone = (phone: string) => {
  if (!phone) {
    phoneError.value = "Por favor, insira seu número de telefone";
    return false;
  }
  // 验证巴西手机号格式：10-11位数字
  const phoneRegex = /^[0-9]{10,11}$/;
  if (!phoneRegex.test(phone)) {
    phoneError.value = "Número de telefone inválido";
    return false;
  }
  phoneError.value = "";
  return true;
};

// 验证验证码
const validateCode = (code: string) => {
  if (!code) {
    verificationCodeError.value = "Por favor, insira o código de verificação";
    return false;
  }
  if (code.length !== 6) {
    verificationCodeError.value = "O código de verificação deve ter 6 dígitos";
    return false;
  }
  if (!/^\d+$/.test(code)) {
    verificationCodeError.value = "O código de verificação deve conter apenas números";
    return false;
  }
  verificationCodeError.value = "";
  return true;
};

// 发送验证码
const sendCode = async () => {
  if (countdown.value > 0) {
    // showError(`Aguarde ${countdown.value} segundos para enviar novamente`);
    return;
  }

  if (!validatePhone(phone.value)) return;

  try {
    loading.value = true;
    const { deviceId } = await generateDeviceFingerprint();
    const fingerprint = md5Encrypt(deviceId);
    let res = await store.dispatch("auth/sendVerificationCode", {
      type: activeTab.value === "phone" ? "indiahm_sms" : "waotp",
      phone: phone.value,
      md5: fingerprint,
    });
    // verificationCode.value = res?.content || "";
    showSuccess("Código enviado com sucesso");
    countdown.value = 60;
    const timer = setInterval(() => {
      countdown.value--;
      if (countdown.value <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  } catch (error: any) {
    showError(error || "Falha ao enviar código");
  } finally {
    loading.value = false;
  }
};
// 输入框点击事件
const handleInputClick = () => {};

// 切换密码显示状态
const showPassword = () => {
  showPasswordFlag.value = !showPasswordFlag.value;
};

// 切换确认密码显示状态
const showConfirmPassword = () => {
  showConfirmPasswordFlag.value = !showConfirmPasswordFlag.value;
};
// 清除手机号
const clearPhone = () => {
  phone.value = "";
  phoneError.value = "";
};

// 清除密码
const clearPassword = () => {
  password.value = "";
  passwordError.value = "";
};

// 清除新密码
const clearNewPassword = () => {
  newPassword.value = "";
  newPasswordError.value = "";
};

// 清除确认新密码
const clearConfirmNewPassword = () => {
  confirmNewPassword.value = "";
  confirmNewPasswordError.value = "";
};

// 清除确认密码
const clearConfirmPassword = () => {
  confirmPassword.value = "";
  confirmPasswordError.value = "";
};

// 切换登录/注册模式
const toggleMode = () => {
  isSignUpMode.value = !isSignUpMode.value;
  toggleModeBtn.value = isSignUpMode.value ? "sign" : "login";
  // 清空表单数据
  phone.value = "";
  password.value = "";
  confirmPassword.value = "";
  cpf.value = "";
  verificationCode.value = "";
  // 重置密码显示状态
  showPasswordFlag.value = false;
  showConfirmPasswordFlag.value = false;
  
  // Clear errors
  phoneError.value = "";
  passwordError.value = "";
  confirmPasswordError.value = "";
  cpfError.value = "";
  verificationCodeError.value = "";
  newPasswordError.value = "";
  confirmNewPasswordError.value = "";
  forgotStep.value = 1;
};

// 切换忘记密码模式
const resetForgotFields = () => {
  verificationCode.value = "";
  newPassword.value = "";
  confirmNewPassword.value = "";
  countdown.value = 0;
  verificationCodeError.value = "";
  newPasswordError.value = "";
  confirmNewPasswordError.value = "";
};

const openForgotDialog = () => {
  forgotStep.value = 1;
  resetForgotFields();
  showForgotDialog.value = true;
};

const closeForgotDialog = () => {
  showForgotDialog.value = false;
  forgotStep.value = 1;
  resetForgotFields();
};

// 验证新密码
const validateNewPassword = (
  newPassword: string,
  confirmNewPassword: string
) => {
  if (!newPassword) {
    newPasswordError.value = "Por favor, insira a nova senha";
    return false;
  }
  if (newPassword.length < 6 || newPassword.length > 16) {
    newPasswordError.value = "6-16 caracteres";
    return false;
  }
  newPasswordError.value = "";
  
  if (!confirmNewPassword) {
    confirmNewPasswordError.value = "Por favor, confirme a nova senha";
    return false;
  }
  if (newPassword !== confirmNewPassword) {
    confirmNewPasswordError.value = "As senhas inseridas duas vezes não correspondem";
    return false;
  }
  confirmNewPasswordError.value = "";
  return true;
};

const handleForgotAction = async () => {
  if (forgotStep.value === 1) {
    if (!validatePhone(phone.value)) return;
    forgotStep.value = 2;
    return;
  }
  if (forgotStep.value === 2) {
    if (!validateCode(verificationCode.value)) return;
    forgotStep.value = 3;
    return;
  }
  await handleResetPassword();
};

// 处理重置密码
const handleResetPassword = async () => {
  if (
    !validatePhone(phone.value) ||
    !validateCode(verificationCode.value) ||
    !validateNewPassword(newPassword.value, confirmNewPassword.value)
  ) {
    return;
  }

  try {
    loading.value = true;
    const params = {
      account_name: phone.value,
      password: newPassword.value,
      code: verificationCode.value,
    };

    const success = await resetPassword(params);
    if (success) {
      showSuccess("Senha redefinida com sucesso");
      // 重置表单并返回登录模式
      phone.value = "";
      verificationCode.value = "";
      newPassword.value = "";
      confirmNewPassword.value = "";
      countdown.value = 0;
      closeForgotDialog();
    }
  } catch (error: any) {
    console.log(error);
    showError(error || "Falha ao redefinir senha");
  } finally {
    loading.value = false;
  }
};

// 验证确认密码
const validateConfirmPassword = (password: string, confirmPassword: string) => {
  if (!confirmPassword) {
    confirmPasswordError.value = "Por favor, confirme sua senha";
    return false;
  }
  if (password !== confirmPassword) {
    confirmPasswordError.value = "As senhas inseridas duas vezes não correspondem";
    return false;
  }
  confirmPasswordError.value = "";
  return true;
};

// 验证密码
const validatePassword = (password: string) => {
  if (!password) {
    passwordError.value = "Por favor, insira sua senha";
    return false;
  }
  if (password.length < 6 || password.length > 16) {
    passwordError.value = "6-16 caracteres";
    return false;
  }
  passwordError.value = "";
  return true;
};

// 验证CPF
const validateCpf = (cpfValue: string) => {
  if (!cpfValue) {
    cpfError.value = "Por favor, insira o CPF";
    return false;
  }
  // 移除非数字字符
  const cleanCpf = cpfValue.replace(/\D/g, '');
  if (cleanCpf.length !== 11) {
    cpfError.value = "CPF inválido, por favor insira 11 dígitos";
    return false;
  }
  cpfError.value = "";
  return true;
};

const acquireFingerprintOrFail = async () => {
  fingerprintLoading.value = true;
  try {
    const fp = await getFingerprintPayload(3000);
    if (!fp) {
      showError("Falha ao obter identificação do dispositivo. Tente novamente.");
      return null;
    }
    return fp;
  } finally {
    fingerprintLoading.value = false;
  }
};

// 处理注册
const handleSignUp = async () => {
  if (
    !validatePhone(phone.value) ||
    !validatePassword(password.value) ||
    !validateConfirmPassword(password.value, confirmPassword.value)
  ) {
    return;
  }
  
  try {
    loading.value = true;
    const { deviceId } = await generateDeviceFingerprint();
    const fingerprint = md5Encrypt(deviceId);
    let params: any = {
      account_name: phone.value,
      password: password.value,
      login_method: 4, // 密码登录
      source: getDeviceCode(),
      md5: fingerprint,
      code: "000000",
      pwa_channel_id: sessionStorage.getItem("promote_url_id") || "",
    };
    const fp = await acquireFingerprintOrFail();
    if (!fp) return;
    params.fingerprint = fp;
    const storedInviteCode = getStoredInviteCode();
    const shortLinkCode = getShortLinkCode();
    
    // 获取代理邀请码 (从 sessionStorage 或解析后的 activityObj)
    const agentInviteCode = sessionStorage.getItem("agent_invite_code") || activityObj.value?.agent_invite_code;
    if (agentInviteCode) {
      params.agent_invite_code = agentInviteCode;
    }

    // agent_invite_code / source_code 二选一：有代理码时不传 source_code
    if (!agentInviteCode) {
      if (activityObj.value?.invite_code) {
        params.source_code = activityObj.value.invite_code;
      } else if (storedInviteCode) {
        // 如果没有解析到 invite_code，则使用短链代码本身作为 fallback
        params.source_code = storedInviteCode;
      } else if (shortLinkCode) {
        params.source_code = shortLinkCode;
      }
    }

    // 判断是否有活动id
    if (Number(activityObj.value?.activity_id)) {
      params.activity_id = parseInt(activityObj.value?.activity_id as string);
    }
    // 判断是否有渠道id
    if (activityObj.value?.channel) {
      params.channel = shortLinkCode || storedInviteCode;
    }

    const pid = sessionStorage.getItem("pid");
    if (pid) {
      const pidNum = Number.parseInt(pid, 10);
      if (Number.isFinite(pidNum)) {
        params.pdd_wheel_invite_code = pidNum;
      }
    }

    const success = await store.dispatch("auth/userRegister", params);
    if (success) {
      console.log(success, 4312421421);
      // 注册埋点
      await GoogleTag("102");
      if(sessionStorage.getItem('channel_id') === "20"){
        window.dataLayer?.push({event: "register", phone: phone.value});
      }
      // 保存密码到本地存储（如果勾选了记住密码）
      savePasswordToStorage();

      // Reset form
      phone.value = "";
      password.value = "";
      confirmPassword.value = "";
      countdown.value = 0;
      // Close dialog
      emit("update:modelValue", false);
      emit("login");
      handleClose();
      // 触发登录成功事件
      eventBus.emit(LOGIN_EVENTS.LOGIN_SUCCESS);
      sessionStorage.removeItem("pid");
      clearInviteTracking();
      localStorage.setItem("isLogin", "true");
      // 获取目标路由并跳转
      const targetRoute = getAndClearTargetRoute();

      // 显示成功提示，但设置较短的超时时间
      console.log(store.state.auth?.registrationBonus);
      if (store.state.auth?.registrationBonus?.register_send_amount) {
        showSuccess(
          "Entrar realizado com sucesso,Recompensas de presente" +
            (
              store.state.auth?.registrationBonus?.register_send_amount / 100
            ).toFixed(0),
          1500
        );
      } else {
        showSuccess("Entrar realizado com sucesso", 1500);
      }

      // 延迟路由跳转，确保 Toast 能够正常显示
      setTimeout(() => {
        if (targetRoute) {
          router.push(targetRoute);
        }
      }, 500);

      // await loginDevice({ }).send();
    } else {
      // showError("Falha ao fazer login");
    }
  } catch (error: any) {
    console.log(error);
    // showError(error || "Falha ao fazer login");
  } finally {
    loading.value = false;
  }
};
// 处理登录
const handleLogin = async () => {
  if (isPasswordLogin.value) {
    if (!validatePassword(password.value) || !validatePhone(phone.value)) {
      return;
    }
  } else {
    if (!validatePhone(phone.value) || !validateCode(verificationCode.value)) {
      return;
    }
  }
  try {
    loading.value = true;
    const { deviceId } = await generateDeviceFingerprint();
    const fingerprint = md5Encrypt(deviceId);
    let params: any = {
      phone: isPasswordLogin.value ? "" : phone.value,
      account_name: phone.value,
      password: password.value,
      code: verificationCode.value || "000000",
      login_method: isPasswordLogin.value ? 4 : 1, // 密码登录
      source: getDeviceCode(),
      md5: fingerprint,
    };
    const fp = await acquireFingerprintOrFail();
    if (!fp) return;
    params.fingerprint = fp;
    const storedInviteCode = getStoredInviteCode();
    const shortLinkCode = getShortLinkCode();

    // 获取代理邀请码 (从 sessionStorage 或解析后的 activityObj)
    const agentInviteCode = sessionStorage.getItem("agent_invite_code") || activityObj.value?.agent_invite_code;
    if (agentInviteCode) {
      params.agent_invite_code = agentInviteCode;
    } else {
      // 判断是否有邀请码
      if (activityObj.value?.invite_code) {
        params.source_code = activityObj.value.invite_code;
      } else if (storedInviteCode) {
        // 普通链接中的 invite_code 需要一直保留到登录成功后再清理
        params.source_code = storedInviteCode;
      } else if (shortLinkCode) {
        // 如果没有解析到 invite_code，则使用短链代码本身作为 fallback
        params.source_code = shortLinkCode;
      }
    }

    // 判断是否有活动id
    if (Number(activityObj.value?.activity_id)) {
      params.activity_id = parseInt(activityObj.value?.activity_id as string);
    }
    // 判断是否有渠道id
    if (activityObj.value?.channel) {
      params.channel = shortLinkCode || storedInviteCode;
    }

    const success = await store.dispatch("auth/login", params);
    if (success) {
      // 保存密码到本地存储（如果勾选了记住密码）
      savePasswordToStorage();
      
      // Close dialog
      emit("update:modelValue", false);
      emit("login");
      handleClose();
      // 触发登录成功事件
      eventBus.emit(LOGIN_EVENTS.LOGIN_SUCCESS);
      clearInviteTracking();
      localStorage.setItem("isLogin", "true");
      // 获取目标路由并跳转
      const targetRoute = getAndClearTargetRoute();

      // 显示成功提示，但设置较短的超时时间
      showSuccess("Entrar realizado com sucesso", 1500);

      // 延迟路由跳转，确保 Toast 能够正常显示
      setTimeout(() => {
        if (targetRoute) {
          router.push(targetRoute);
        }
      }, 500);
    } else {
      // showError("Falha ao fazer login");
    }
  } catch (error: any) {
    showError(error);
  } finally {
    loading.value = false;
  }
};

const handleClose = () => {
  show.value = false;
};

// 监听toggleModeBtn的变化，以决定是否清空表单
watch(toggleModeBtn, (newVal, oldVal) => {
  // if (newVal !== oldVal) {
  //   phone.value = "";
  //   password.value = "";
  //   verificationCode.value = "";
  //   confirmPassword.value = "";
  //   // 重置密码显示状态
  //   showPasswordFlag.value = false;
  //   showConfirmPasswordFlag.value = false;
  // }
});

const activityBtn = () => {
  if (isSignUpMode.value) {
    return phone.value && password.value && confirmPassword.value;
  }
  return phone.value && password.value;
};
</script>

<style lang="scss" scoped>
.login-dialog {
  :deep(.v-overlay__content) {
    margin: 16px;
    max-height: calc(100% - 32px);
    width: auto;
    max-width: 850px;
    
    @media (max-width: 768px) {
      margin: 0;
      max-height: 100%;
      width: 100%;
      max-width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}

.login-dialog-bottom {
  :deep(.v-overlay__content) {
    position: absolute;
    bottom: 0;
    margin: 0;
    width: 100%;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    animation: slideUp 0.3s ease-out;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.login-card {
  width: 100%;
  background-color: #1E2536;
  border-radius: 16px;
  overflow: hidden;
  color: white;
  padding: 32px;
  position: relative;
  
  &.mobile {
    padding: 0;
    border-radius: 20px 20px 0 0;
    border-top: 2px solid #29b6f6;
    box-shadow: 0 -4px 20px rgba(41, 182, 246, 0.3);
    min-height: 40vh;
    max-height: 90vh;
    overflow-y: auto;
  }
}

.login-card :deep(.v-input__details) {
  min-height: 0;
  padding: 2px 0 0;
}

.login-card :deep(.v-field__input input) {
  letter-spacing: 0 !important;
  font-family: Arial, Helvetica, sans-serif !important;
}

.mobile-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px;
}

.login-tabs {
  margin-bottom: 24px;
  
  .tab-btn {
    color: rgba(255, 255, 255, 0.6);
    font-size: 16px;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0;
    
    &.active {
      color: #fff;
      font-weight: 600;
    }
  }
  
  .login-title-sign, .login-title-login {
    flex: 1;
    height: 40px;
    border-radius: 32px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    background: transparent;
    box-shadow: none;
    
    &.activeTabBg {
      background: #29b6f6;
      color: #fff;
    }
    
    :deep(.v-btn__content) {
      width: 100%;
    }
  }
  
  .login-title-forget {
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 24px;
  }
}

.forgot-header {
  margin-bottom: 16px;
  text-align: left;
}

.forgot-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
}

.forgot-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 12px;
}

.forgot-dialog {
  :deep(.v-overlay__content) {
    margin: 0 16px;
    max-width: 360px;
    width: 100%;
  }
}

.forgot-card {
  background: #1E2536;
  border-radius: 16px;
  padding: 24px;
  color: #fff;
}

.forgot-card :deep(.v-input__details) {
  min-height: 0;
  padding: 2px 0 0;
}

.forgot-card :deep(.v-field__input input) {
  letter-spacing: 0 !important;
  font-family: Arial, Helvetica, sans-serif !important;
}

.forgot-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.forgot-card-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.forgot-close-btn {
  width: 32px;
  height: 32px;
}

.forgot-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
}

.forgot-step {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.forgot-step.active {
  background: #29b6f6;
  border-color: #29b6f6;
  color: #fff;
}

.forgot-step-line {
  width: 28px;
  height: 2px;
  background: rgba(255, 255, 255, 0.2);
}

.forgot-step-line.active {
  background: #29b6f6;
}

.phone-input, .code-input {
  margin-bottom:0px;
  
  :deep(.v-field) {
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    
    &.v-field--focused {
      border-color: #29b6f6;
    }
  }
  
  :deep(.v-field__input) {
    color: #fff;
    font-size: 14px;
    letter-spacing: 0 !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  
  :deep(.v-label) {
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
  }
  
  .clear-btn {
    color: rgba(255, 255, 255, 0.3);
    &:hover {
      color: rgba(255, 255, 255, 0.6);
    }
  }
  
  .show-pass-btn {
    color: rgba(255, 255, 255, 0.6);
  }
  
  .send-code-btn {
    color: #29b6f6;
    font-weight: 600;
    font-size: 14px;
    text-transform: none;
  }
}

.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  
  .remember-checkbox {
    margin: 0;
    padding: 0;
    
    :deep(.v-label) {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
    }
    
    :deep(.v-selection-control) {
      min-height: auto;
    }
  }
  
  .forgot-password {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

.login-btn {
  background: linear-gradient(90deg, var(--ep-color-background-fill-gradients-primary-a, #4DB492) -27.5%, var(--ep-color-background-fill-gradients-primary-b, #C5CB55) 127.5%);
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  border-radius: 8px;
  text-transform: none;
  height: 48px;
  
  &.active-login-btn {
    opacity: 1;
  }
  
  &:disabled {
    opacity: 0.5;
    background: #333;
    color: rgba(255, 255, 255, 0.3);
  }
}

.mobile-login-btn {
  @extend .login-btn;
  width: 100%;
  touch-action: manipulation;
}

.sing-up-bottom {
  margin-top: 16px;
  
  .tips-checkbox {
    :deep(.v-label) {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1.4;
    }
  }
  
  .sign-up-btn {
    color: #29b6f6;
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
  }
}

.mobile-login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.mobile-drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  
  .drawer-logo {
    height: 32px;
  }
  
  .close-btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.mobile-login-drawer {
  background: #1E2536;
  border-radius: 20px 20px 0 0;
  padding: 24px;
  padding-bottom: 40px;
  border-top: 2px solid #29b6f6;
  box-shadow: 0 -4px 20px rgba(41, 182, 246, 0.3);
  flex: 1;
  max-height: none;
  overflow-y: auto;
  
  .mobile-input {
    @extend .phone-input;
    
    :deep(.v-field) {
      background: #111827;
      border-color: transparent;
    }
  }
}

@media (min-width: 601px) {
  .mobile-login-overlay {
    max-width: 486px;
    left: 50% !important;
    transform: translateX(-50%);
  }
}
</style>
